import React from 'react';
import BuildAnalytics from '../BuildAnalytics';

const AssociateChart = () => <BuildAnalytics type={'associate-charts'} />;

export default AssociateChart;
